import { Card, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { formatCurrency } from '@/lib/utils/formatters';

interface ServicosNfseSummaryCardsProps {
  totalServicosTomados: number;
  /** `null` quando a lista não traz o total do período: aí o cartão não inventa um zero. */
  totalCreditoIBS: number | null;
  totalCreditoCBS: number | null;
  totalCredito: number | null;
}

const SEM_TOTAL_DO_PERIODO = 'Total do período indisponível';

/**
 * O número só aparece quando a lista traz o total do período. A rota nativa da lista não o devolve (o legado
 * somava), e o cartão mostrava R$ 0,00 como se não houvesse crédito. O total da apuração de NFS-e (SPEC-011, PR 1)
 * sai numa rota própria, e não na lista: o número só volta com outro PR, que faça a lista devolver o total ou o
 * cartão ler a apuração. Até lá, "—".
 */
function ValorDoCredito({ valor }: { valor: number | null }) {
  if (valor === null) {
    return (
      <>
        <CardTitle className="text-2xl text-muted-foreground">—</CardTitle>
        <p className="text-xs text-muted-foreground">{SEM_TOTAL_DO_PERIODO}</p>
      </>
    );
  }

  return <CardTitle className="text-2xl text-green-600">{formatCurrency(valor)}</CardTitle>;
}

export function ServicosNfseSummaryCards({
  totalServicosTomados,
  totalCreditoIBS,
  totalCreditoCBS,
  totalCredito,
}: ServicosNfseSummaryCardsProps) {
  return (
    <div className="mb-8 grid gap-6 md:grid-cols-4">
      <Card>
        <CardHeader className="pb-3">
          <CardDescription>Total Serviços Tomados</CardDescription>
          <CardTitle className="text-3xl">{totalServicosTomados}</CardTitle>
        </CardHeader>
      </Card>
      <Card>
        <CardHeader className="pb-3">
          <CardDescription>Crédito IBS Disponível</CardDescription>
          <ValorDoCredito valor={totalCreditoIBS} />
        </CardHeader>
      </Card>
      <Card>
        <CardHeader className="pb-3">
          <CardDescription>Crédito CBS Disponível</CardDescription>
          <ValorDoCredito valor={totalCreditoCBS} />
        </CardHeader>
      </Card>
      <Card>
        <CardHeader className="pb-3">
          <CardDescription>Crédito Total</CardDescription>
          <ValorDoCredito valor={totalCredito} />
        </CardHeader>
      </Card>
    </div>
  );
}
